<template>
  <div class="action-bar">
    <button
      type="button"
      class="action-btn user-pill"
      @click="$emit('profile')"
    >
      <span class="user-role">{{ roleLabel }}</span>
      <strong class="user-name">{{ username }}</strong>
    </button>

    <el-badge :value="unreadCount" :hidden="!unreadCount" class="message-badge">
      <el-button class="action-btn message-btn" @click="$emit('notifications')">
        <el-icon><Bell /></el-icon>
        <span>站内信</span>
      </el-button>
    </el-badge>

    <el-button class="action-btn logout-btn" @click="handleLogout">
      <el-icon><SwitchButton /></el-icon>
      <span>退出登录</span>
    </el-button>
  </div>
</template>

<script>
import { ElMessageBox } from 'element-plus'
import { Bell, SwitchButton } from '@element-plus/icons-vue'

export default {
  name: 'WorkspaceActionBar',
  components: {
    Bell,
    SwitchButton
  },
  props: {
    unreadCount: {
      type: Number,
      default: 0
    },
    username: {
      type: String,
      default: ''
    },
    roleLabel: {
      type: String,
      default: ''
    }
  },
  emits: ['logout', 'notifications', 'profile'],
  methods: {
    isCancelAction(error) {
      return error === 'cancel' || error === 'close'
    },
    async handleLogout() {
      try {
        await ElMessageBox.confirm('确认退出当前账号并返回登录页吗？', '退出确认', {
          type: 'warning',
          confirmButtonText: '确认退出',
          cancelButtonText: '取消'
        })
        this.$emit('logout')
      } catch (error) {
        if (this.isCancelAction(error)) {
          return
        }
      }
    }
  }
}
</script>

<style scoped>
.action-bar {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(14px);
}

.message-badge :deep(.el-badge__content) {
  top: 8px;
  right: 12px;
  border: 2px solid #fff;
}

.action-btn {
  height: 46px;
  padding: 0 16px;
  border: 1px solid transparent;
  border-radius: 14px;
  font-weight: 600;
  box-shadow: none;
}

.action-btn :deep(.el-icon) {
  margin-right: 8px;
}

.user-pill {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 178px;
  background: #f8fafc;
  border-color: #e2e8f0;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
}

.user-pill:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.08);
}

.user-pill:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.message-btn {
  color: #0f172a;
  background: #eef4ff;
  border-color: #cfe0ff;
}

.message-btn:hover {
  color: #0f172a;
  background: #e0ecff;
  border-color: #bfd4ff;
}

.user-role {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #475569;
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
}

.user-name {
  font-size: 15px;
  color: #0f172a;
  line-height: 1;
}

.logout-btn {
  color: #b91c1c;
  background: #fff1f2;
  border-color: #fecdd3;
}

.logout-btn:hover {
  color: #991b1b;
  background: #ffe4e6;
  border-color: #fda4af;
}

@media (max-width: 768px) {
  .action-bar {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
  }

  .message-badge {
    width: 100%;
  }

  .message-badge :deep(.el-badge) {
    width: 100%;
  }

  .action-btn {
    width: 100%;
  }

  .user-pill {
    min-width: 0;
    justify-content: space-between;
  }
}
</style>
